import Sidebar from "./Sidebar"
import Header from "./Header"
import Footer from "./Footer"

const Layout = ({ children, title = "Dashboard" }) => {
  return (
    <div className="flex min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50 flex-col">
      <Sidebar />
      <div className="flex-1 md:ml-64 flex flex-col">
        <Header title={title} />
        <main className="p-4 mt-16 md:p-6 flex-grow pb-4">{children}</main>
        <Footer />
      </div>
    </div>
  )
}

export default Layout
